import { render, staticRenderFns } from "./CoinsurancePremium.vue?vue&type=template&id=388e2f98&"
import script from "./CoinsurancePremium.vue?vue&type=script&lang=js&"
export * from "./CoinsurancePremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports